import { render, staticRenderFns } from "./LinkLabel.vue?vue&type=template&id=2b112a78&scoped=true&"
import script from "./LinkLabel.vue?vue&type=script&lang=js&"
export * from "./LinkLabel.vue?vue&type=script&lang=js&"
import style0 from "./LinkLabel.vue?vue&type=style&index=0&id=2b112a78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b112a78",
  null
  
)

export default component.exports